import {Link} from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";
import Header from "../Header";
import Button from "../component-assets/Button";
import ApiRequester from "../ApiRequester";
import {
    convertSectoHHMM,
    formatDateIso,
    iAmHigherAuthority,
    formCheck,
    formFail,
    formSuccess,
    getToday,
    handleSubmitActions,
    HHMMtoLocalTime,
    setDeviceFilters,
    toggleCollapse,
    showModal,
    isBannerPresent,
    sortFunc,
    serverid_to_mac, mac_to_serverid, convertIsoToLocal, convertIsoUTCToLocalized, getUTCTimestamp
} from "../../libs";
import {Chart, registerables} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import TableBody from "../component-assets/TableBody";
import TableHeaders from "../component-assets/TableHeaders";
import MapController from "../component-assets/MapController";
import {MapContainer, Marker, Popup} from "react-leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import Navigation from "../Navigation";
import HourlyLineAndBarChart from "../charts/HourlyLineAndBarChart";
import LineTrendingChart from "../charts/LineTrendingChart";
import ProfileSkeleton from "../component-assets/skeletons/ProfileSkeleton";

const PalcareDevice = (props) => {
    let dData, bData, startDate, endDate, eventHeaderData, noteHeaderData;

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    eventHeaderData = [
        {label: "Event Start", key: "event_datetime_local", align: "center", sorts: false,
            link: {enabled: true, linkto: "/profiles/event", linkkey: "event_id", type: "datetime"}},
        {label: "Response Time (min)", key: "response_time", align: "center", sorts: false},
        {label: "Resident", key: "resident_name", align: "left", sorts: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/resident", linkkey: "resident_id"}},
        {label: "Location", key: "area_name", align: "left", sorts: false,
            link: {enabled: true, type: "standard", linkto: "/profiles/area", linkkey: "area_id"}},
        {label: "Reason", key: "reason_code_description", align: "center", type: "indicator", sorts: false,
            indicator: {enabled: dData?.is_reason_editable, type: "length", key: "reason_edits",
                title: "This value has been edited"}}
    ];

    noteHeaderData = [
        {label: "Timestamp", key: "create_time", align: "center", type: "datetime-utc", sorts: false},
        {label: "Created By", key: "display_name", align: "center", sorts: false},
        {label: "Note", key: "note", align: "left", sorts: false},
    ]

    // Permission Variables
    const [editRights, setEditRights] = useState(iAmHigherAuthority(10, dData.role_weight));
    const [read, setRead] = useState(true);
    // Main Page Variables
    const [deviceId, setDeviceId] = useState(props?.id);
    const [count, setCount] = useState(0);
    const [repCount, setRepCount] = useState(0);
    const [campusId, setCampusId] = useState(dData.acnt);
    const [tabItem, setTabItem] = useState("init");
    const [storedIndex, setStoredIndex] = useState(0);
    const [prenoteData, setPrenoteData] = useState([]);
    const [prenoteOptions, setPrenoteOptions] = useState([]);
    const [profileData, setProfileData] = useState([]);
    const [profileOptions, setProfileOptions] = useState([]);
    // Load Variables
    const [basicDataLoaded, setBasicDataLoaded] = useState(false); // Goes into Basic
    const [resLoaded, setResLoaded] = useState(false); // Goes into Basic
    const [areaLoaded, setAreaLoaded] = useState(false); // Goes into Basic
    const [profilesLoaded, setProfilesLoaded] = useState(false); // Goes into Basic
    const [basicLoaded, setBasicLoaded] = useState(false); // Handles Basic Tab Display
    const [hourDataLoaded, setHourDataLoaded] = useState(false); // Goes into Report
    const [weekDataLoaded, setWeekDataLoaded] = useState(false); // Goes into Report
    const [eventDataLoaded, setEventDataLoaded] = useState(false); // Goes into Report
    const [reasonDataLoaded, setReasonDataLoaded] = useState(false); // Goes into Report
    const [reportLoaded, setReportLoaded] = useState(false); // Handles Report Tab Display
    const [careDataLoaded, setCareDataLoaded] = useState(false); // Goes into Wellness
    const [wellnessLoaded, setWellnessLoaded] = useState(false); // Handles Wellness Tab Display
    const [pageLoaded, setPageLoaded] = useState(false);
    // LineTrendingVariables
    const [lineData, setLineData] = useState([]);
    const [lineColors, setLineColors] = useState([]);
    const [lineLabels, setLineLabels] = useState([]);
    const [lineAxisLabels, setLineAxisLabels] = useState([]);
    // Basic Information Variables
    const [basicData, setBasicData] = useState([]);
    const [areaData, setAreaData] = useState([]);
    const [residentData, setResidentData] = useState([]);
    const [areaGroups, setAreaGroups] = useState([]);
    const [resGroups, setResGroups] = useState([]);
    const [serialNum, setSerialNum] = useState("");
    const [description, setDescription] = useState("");
    const [residentId, setResidentId] = useState(0);
    const [areaId, setAreaId] = useState(0);
    const [deviceImg, setDeviceImg] = useState("");
    const [dspProfileId, setDspProfileId] = useState(0);
    const [isActive, setIsActive] = useState(0);
    const [deviceType, setDeviceType] = useState("");
    // Reporting Variables
    const [weekData, setWeekData] = useState({});
    const [hourData, setHourData] = useState({});
    const [reasonData, setReasonData] = useState({});
    const [reasonRows, setReasonRows] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [eventTableRows, setEventTableRows] = useState([]);
    const [noteTableRows, setNoteTableRows] = useState([]);
    const [noteTableLength, setNoteTableLength] = useState(0);
    const [markers, setMarkers] = useState("");
    const [mapCont, setMapCont] = useState(<></>);
    const [findMarkers, setFindMarkers] = useState(<></>);
    const [penLocData, setPenLocData] = useState([]);
    const [findMap, setFindMap] = useState("");
    const [isFinding, setIsFinding] = useState(false);
    const [isActivating, setIsActivating] = useState(false);
    const [findDate, setFindDate] = useState("");
    const [findCnt, setFindCnt] = useState(0);
    const [markLat, setMarkLat] = useState(dData?.campusData[campusId]?.latitude ? dData.campusData[campusId].latitude : 0);
    const [markLong, setMarkLong] = useState(dData?.campusData[campusId]?.longitude ? dData.campusData[campusId].longitude : 0);
    // Wellness Variables
    const [areaWellData, setAreaWellData] = useState([]);
    const [careData, setCareData] = useState([]);
    const [careflow, setCareflow] = useState([]);
    // Other
    const [campusLat, setCampusLat] = useState(dData?.campusData[campusId]?.latitude ? dData.campusData[campusId].latitude : 0);
    const [campusLong, setCampusLong] = useState(dData?.campusData[campusId]?.longitude ? dData.campusData[campusId].longitude : 0);

    startDate = formatDateIso(getToday(-28));
    endDate = formatDateIso(getToday());

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "myfetch", payload: {device_filter: deviceId, campus_id: campusId},
                          procedure: "getpalcaredeviceprofile", reqType: "stored", "read-only": read}).then(data => {
                setBasicData(data?.length > 0 ? data[0] : {});
                setBasicDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {campus_id: campusId},
                          procedure: "getppendantdspprofilelist", reqType: "stored", "read-only": true}).then(data => {
                setProfileData(data ? data : []);
                setProfilesLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": true,
                                procedure: "sp_dev_getareasbycampusid", reqType: "stored"}).then(data => {
                setAreaData(data ? data : []);
                setAreaLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": true,
                                procedure: "sp_dev_getresidentsbycampusid", reqType: "stored"}).then(data => {
                setResidentData(data ? data : []);
                setResLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch",
                          payload: {campus_id: campusId, care_types: "1,3,4,5", care_event_types: "1"},
                          procedure: "getcareflowwindows", reqType: "stored", "read-only": true}).then(data => {
                setCareData(data);
                setCareDataLoaded(true);
            });
            setRead(true);
            setCount(() => 600);
        }
        return () => clearInterval(interval);
    }, [count]);

    useEffect(() => {
        if (![basicLoaded, reportLoaded, wellnessLoaded].includes(false)){
            setPageLoaded(true);
        }
    }, [basicLoaded, reportLoaded, wellnessLoaded]);

    useEffect(() => {
        if (![basicDataLoaded, resLoaded, areaLoaded, profilesLoaded].includes(false)){
            setBasicLoaded(true);
            if (tabItem === "init") {
                setTabItem("basic");
            }
        }
    }, [basicDataLoaded, resLoaded, areaLoaded, profilesLoaded]);

    useEffect(() => {
        if ([hourDataLoaded, weekDataLoaded, eventDataLoaded, reasonDataLoaded].every((item) => item === true)){
            setReportLoaded(true);
        }
    }, [hourDataLoaded, weekDataLoaded, eventDataLoaded, reasonDataLoaded]);

    useEffect(() => {
        if ([careDataLoaded].every((item) => item === true)){
            setWellnessLoaded(true);
        }
    }, [careDataLoaded]);

    useEffect(() => {
        if ((isFinding || isActivating) && findDate !== ""){
            let interval = null;
            interval = setInterval(() => {
                 setFindCnt(count => count - 1);
            }, 1000);
            if (findCnt <= 0) {
                ApiRequester({reqEndpoint: "myfetch", "read-only": false,
                          payload: {campus_id: campusId, mac: serialNum, last_date: findDate},
                          procedure: "getpalcarelastlocation", reqType: "stored"}).then(data => {
                    setPenLocData(data);
                    if (data.length > 0){
                        setFindDate("");
                    }
                });
                setFindCnt(5);
            }
            return () => clearInterval(interval);
        }
    }, [isFinding, isActivating, findCnt, findDate]);

    useEffect(() => {
        if (penLocData.length > 0 && (isFinding || isActivating)){
            let penLoc = penLocData[0]
            let tmp = [];
            tmp.push(
                <Marker
                    position={[penLoc.latitude, penLoc.longitude]}
                    key={`find-marker-1`}>
                    <Popup className={"fs-4"}>
                        Found at: {convertIsoUTCToLocalized(penLoc.create_time)}
                        <br/>
                        Lat: {penLoc.latitude}
                        <br/>
                        Long: {penLoc.longitude}
                    </Popup>
                </Marker>
            );
            setFindMarkers(tmp);
            setMarkLat(penLoc.latitude);
            setMarkLong(penLoc.longitude);
            setIsFinding(false);
            setIsActivating(false);
        }
    }, [penLocData]);

    useEffect(() => {
        if (areaData.length > 0){
            setAreaData(areaData.sort((a, b) => sortFunc(a, b, "area_name", "asc")));
        }
    }, [areaData]);

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setRepCount(repCount => repCount - 1);
        }, 1000);
        if (repCount <= 0){
            {dData?.event_notes_active && dData.event_notes_preform &&
                ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_preform_event_notes",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": read}).then(data => {
                    setPrenoteData(data);
                });
            }
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "dashboardhourchart",
                                campus_id: campusId, device_filter: deviceId.toString()}).then(data => {
                setHourData(data);
                setHourDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "dashboardweekchart",
                                campus_id: campusId, device_filter: deviceId.toString()}).then(data => {
                setWeekData(data);
                setWeekDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "eventReasonSummary",
                        campus_id: campusId, start_date: startDate, end_date: endDate,
                        device_category_filter: "", area_type_filter: "", reason_filter: "", user_filter: "",
                        event_type_filter: "", resident_filter: "", device_filter: deviceId.toString()}).then(data => {
                setReasonData(() => data ? data : []);
                setReasonDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {campus_id: campusId, device_id: deviceId.toString()},
                                procedure: "getlimitedevents", reqType: "stored", "read-only": true}).then(data => {
                setEventData(data);
                setEventDataLoaded(true);
            });
            setRead(true);
            setRepCount(repCount => 1200);
        }
        return () => clearInterval(interval);
    }, [repCount]);

        useEffect(() => {
        if (Object.keys(basicData).length > 0){
            setAreaGroups(() => basicData?.area_groups ? basicData.area_groups : []);
            setResGroups(() => basicData?.resident_groups ? basicData.resident_groups : []);
            setIsActive(() => basicData?.is_active ? basicData.is_active : 0);
            setDescription(() => basicData?.descriptions ? basicData.descriptions : "");
            setAreaId(() => basicData?.area_id ? basicData.area_id : 0);
            setResidentId(() => basicData?.resident_id ? basicData.resident_id : 0);
            setSerialNum(() => basicData?.manufacture_uuid ? basicData.manufacture_uuid : "");
            setDeviceImg(basicData?.image_url ? basicData?.image_url : "");
            setDeviceType(basicData?.device_type_name ? basicData.device_type_name : "");
            setDspProfileId(basicData?.dsp_profile_id ? basicData.dsp_profile_id : 0);
        }
    }, [basicData]);

    useEffect(() => {
        let tmpAflows = [], tmpDflows = [], tmpDevflows = [], tmpRflows = [], allFlows;
        if (careData?.length > 0){
            for (let i=0; i < careData?.length; i++){
                if (careData[i].escalation_type_id === 1){
                    tmpDflows.push(<>
                        <div key={`cfd-1-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                            {careData[i].careflow_description}
                        </div>
                        <div key={`cft-1-${i}`} className={"d-inline-block align-top ms-1"}>
                            {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Default)
                        </div>
                    </>);
                }else if (careData[i].escalation_type_id === 3){
                    if (careData[i]?.references.split(",").includes(deviceId.toString())){
                        tmpDevflows.push(<>
                            <div key={`cfd-3-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                                {careData[i].careflow_description}
                            </div>
                            <div key={`cft-3-${i}`} className={"d-inline-block align-top ms-1"}>
                                {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Device)
                            </div>
                        </>);
                    }
                }else if (careData[i].escalation_type_id === 4){
                    for (let i2=0; i2 < resGroups?.length; i2++){
                        if (careData[i]?.references.split(",").includes(resGroups[i2]?.resident_group_id?.toString())){
                            tmpRflows.push(<>
                                <div key={`cfd-4-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                                    {careData[i].careflow_description}
                                </div>
                                <div key={`cft-4-${i}`} className={"d-inline-block align-top ms-1"}>
                                    {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Resident)
                                </div>
                            </>);
                        }
                    }
                }else if (careData[i].escalation_type_id === 5){
                    for (let i3=0; i3 < areaGroups?.length; i3++){
                        if (careData[i]?.references.split(",").includes(areaGroups[i3]?.area_group_id?.toString())){
                            tmpAflows.push(<>
                                <div key={`cfd-5-${i}`} className={"d-inline-block"} style={{minWidth: "175px", maxWidth: "175px", textOverflow: "ellipsis"}}>
                                    {careData[i].careflow_description}
                                </div>
                                <div key={`cft-5-${i}`} className={"d-inline-block align-top ms-1"}>
                                    {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_start))} - {HHMMtoLocalTime(convertSectoHHMM(careData[i].enable_end))} (Area)
                                </div>
                            </>);
                        }
                    }
                }
            }
            allFlows = tmpDevflows.concat(tmpRflows, tmpAflows, tmpDflows);
            setCareflow(allFlows.map((item, i) => {return <div key={`cf-item-${i}`}>{item}<br/></div>}));
        }
    }, [careData, areaGroups, resGroups]);

    useEffect(() => {
        let tmp = [];
        if (prenoteData.length > 0){
            for (let i=0; i < prenoteData.length; i++){
                tmp.push(
                    <option key={`prenote-option-${i}`} value={prenoteData[i]?.preform_note}>{prenoteData[i]?.preform_note}</option>
                );
            }
        }
        if (dData?.event_notes_freeform){
            tmp.push(
                <option key={`prenote-option-00`} value={"0"}>Other (freeform note)</option>
            );
        }
        setPrenoteOptions(() => tmp);
    }, [prenoteData]);

    useEffect(() => {
        let tmp = [];
        if (profilesLoaded && profileData.length > 0){
            for (let i=0; i < profileData.length; i++){
                tmp.push(
                    <option key={`profile-option-${i}`} value={profileData[i]?.dsp_profile_id}>{profileData[i]?.profile_name}</option>
                );
            }
        }
        setProfileOptions(() => tmp);
    }, [profileData, profilesLoaded]);

    useEffect(() => {
        if (eventData.length > 0){
            let tmp = [];
            if (dData?.event_notes_active){
                setEventTableRows(<TableBody start={0} end={eventData.length} tableData={eventData} checkbox={false}
                                             writeAccess={true} unk={"dev-"} modalType={"add"} modalLabel={"Add Note"}
                                             actionAppearance={() => {}} parentComponent={"InovonicsDevice"}
                                             tableHeaders={eventHeaderData} modal={true} editModal={addNoteModal}
                                             dData={dData} checkboxlist={[]} editModalBadge={"notes"}
                                             setCheckboxId={() => {}} checkidkey={""} />);
            }else{
                setEventTableRows(<TableBody start={0} end={eventData.length} tableData={eventData} checkbox={false}
                                             writeAccess={true} unk={"dev-"} modalType={"add"} modalLabel={"Add Note"}
                                             actionAppearance={() => {}} parentComponent={"InovonicsDevice"}
                                             tableHeaders={eventHeaderData} modal={false} editModal={() => {}}
                                             dData={dData} checkboxlist={[]} editModalBadge={"notes"}
                                             setCheckboxId={() => {}} checkidkey={""} />);
            }
            for (let i=0; i < eventData.length; i++){
                if (![0, null, undefined].includes(eventData[i]?.latitude) && ![0, null, undefined].includes(eventData[i]?.longitude)){
                    tmp.push(
                        <Marker
                            position={[eventData[i].latitude, eventData[i].longitude]}
                            key={`map-marker-${i}`}>
                            <Popup className={"fs-4"}>
                                Event Time: {convertIsoToLocal(eventData[i]?.event_datetime_local)}<br/>
                                Event Clear: {convertIsoToLocal(eventData[i]?.ack_datetime_local)}<br/>
                                Response: {eventData[i]?.response_time} Minutes<br/>
                                Reason: {eventData[i]?.reason_code_description ? eventData[i].reason_code_description : "No Reason"}
                            </Popup>
                        </Marker>
                    );
                }
            }
            setMarkers(tmp)
        }
    }, [eventData]);

    useEffect(() => {
       if (tabItem === "reporting"){
           setMapCont(() =>
               <MapContainer className={"rounded"}
                          zoom={19}
                          id={"event-map-container"}
                          scrollWheelZoom={true}
                          center={eventData.length > 0 ? [eventData[0].latitude, eventData[0].longitude] : [campusLat, campusLong]}>
                {/*<TileLayer*/}
                {/*    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
                {/*    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>*/}
                    <ReactLeafletGoogleLayer apiKey={"AIzaSyDWuEm0U-KbxGBwYlNyc3eiKM1lbWcocis"} type={"roadmap"} />
                {markers}
            </MapContainer>
           );
       }
    }, [tabItem, markers]);

    useEffect(() => {
        if (tabItem === "find"){
            setFindMap(() =>
                <MapContainer className={"rounded"}
                              zoom={19}
                              id={"find-map-container"}
                              scrollWheelZoom={true}
                              center={[campusLat, campusLong]}>
                    {/*<TileLayer*/}
                    {/*    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
                    {/*    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>*/}
                        <ReactLeafletGoogleLayer apiKey={"AIzaSyDWuEm0U-KbxGBwYlNyc3eiKM1lbWcocis"} type={"roadmap"} />
                    <MapController lat={markLat} lng={markLong}/>
                    {findMarkers}
                </MapContainer>);
        }
    }, [tabItem, findMarkers, markLat, markLong]);

    useEffect(() => {
        if (weekData){
            setLineColors(["#0081C7"]);
            setLineLabels(["Total Alarms"]);
            setLineData([weekData?.events?.length > 0 ? weekData.events : []]);
            setLineAxisLabels(weekData?.labels?.length > 0 ? weekData.labels : []);
        }
    }, [weekData]);

    function basicActionHandling(){
        document.getElementById("description-static").classList.toggle("d-none");
        document.getElementById("description-edit").classList.toggle("d-none");
        document.getElementById("serialnum-static").classList.toggle("d-none");
        document.getElementById("serialnum-edit").classList.toggle("d-none");
        document.getElementById("linked-static")?.classList?.toggle("d-none");
        document.getElementById("linked-edit")?.classList?.toggle("d-none");
        document.getElementById("profile-static")?.classList?.toggle("d-none");
        document.getElementById("profile-edit")?.classList?.toggle("d-none");
        if (document.getElementById("edit-basic-btn").innerText === "Edit"){
            document.getElementById("edit-basic-btn").innerText = "Cancel";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
            document.getElementById("serialnum-edit").value = basicData?.manufacture_uuid;
            document.getElementById("description-edit").value = basicData?.descriptions;
            if (basicData?.device_type === "location"){
                document.getElementById("linked-edit").value = basicData?.area_id;
            }else{
                document.getElementById("linked-edit").value = basicData?.resident_id;
            }
        }else{
            document.getElementById("edit-basic-btn").innerText = "Edit";
            document.getElementById("save-basic-btn").classList.toggle("d-none");
        }
        formCheck("basic-form", "save-basic-btn");
    }

    function basicSubmit(){
        let description, linkedId, payload, linkedEntity, serialnum, oldPayload, profileId, profileItem;
        if (editRights){
            handleSubmitActions("save-basic-btn", "load-basic-btn");
            description = document.getElementById("description-edit").value;
            linkedEntity = document.getElementById("linked-edit");
            profileItem = document.getElementById("profile-edit");
            profileId = profileItem?.value ? parseInt(profileItem.value) : 0;
            linkedId = linkedEntity?.value ? parseInt(linkedEntity.value) : 0;
            serialnum = mac_to_serverid(document.getElementById("serialnum-edit").value);
            payload = [{device_id: parseInt(deviceId), descriptions: description, is_active: linkedId !== 0,
                        area_id: basicData?.is_area_device === 1 ? parseInt(linkedId) : 0, dsp_profile_id: profileId,
                        resident_id: basicData?.is_resident ? parseInt(linkedId) : 0,
                        manufacture_uuid: serialnum.toString(), modified_by: dData.user,
                        offsite: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_active,
                        offsite_id: dData?.campusData[dData.acnt.toString()]?.offsite_vendor_id}];
            oldPayload = [{device_id: parseInt(deviceId), descriptions: description, is_active: isActive ? 1 : 0,
                           area_id: areaId, resident_id: residentId, manufacture_uuid: serialNum, dsp_profile_id: dspProfileId}];
            ApiRequester({reqEndpoint: "mytransaction", TransType: "device_edit_basic", Payload: payload,
                                CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                                ClientId: dData.sessionId}).then(data => {
                if (data && data[0]){
                    setRead(false);
                    setCount(0);
                    formSuccess("Basic information saved.", "save-basic-btn", "load-basic-btn", "edit-basic-btn")
                }
                else{
                    formFail(`Error during save, error code: ${data && data?.length > 1 ? data[1] : ""}`,
                        "save-basic-btn", "load-basic-btn");
                }
            });
        }else{
            toast.warn("You do not have permissions to perform this action.");
        }
    }

    function addNoteModal(rowIndex){
        let dataIndex;
        dataIndex = parseInt(rowIndex);
        setStoredIndex(dataIndex);
        document.getElementById("note").value = "";
        setNoteTableLength(eventData[dataIndex].notes.length);
        setNoteTableRows(<TableBody start={0} end={eventData[dataIndex].notes.length}
                                    tableData={eventData[dataIndex].notes} checkbox={false}
                                     writeAccess={false} unk={"n-"} actionAppearance={() => {}}
                                     tableHeaders={noteHeaderData} modal={false}
                                     parentComponent={"Event"} dData={dData} checkboxlist={[]}
                                     setCheckboxId={() => {}} checkidkey={"note_id"}
                                     tzOffset={parseInt(dData?.campusData[campusId]?.tz_offset ? dData?.campusData[campusId]?.tz_offset : 0)}/>);
        formCheck("addNoteForm", "addNoteSubmit");
        showModal("addnotemodal");
    }

    function addNoteSubmit(){
        let payload, eventId, note;
        handleSubmitActions("addNoteSubmit", "loadAddNoteSubmit");
        eventId = eventData[storedIndex]?.event_id;
        note = document.getElementById("note").value;
        if (note === "0"){
            note = document.getElementById("note-freeform").value;
        }
        payload = [{event_id: eventId, campus_id: dData.acnt, note: note, modified_by: dData?.user}];
        ApiRequester({reqEndpoint: "mysave", Tbl: "core_event_notes", Payload: payload, urlType: "PUT",
                            User: dData.user, PKey: "note_id", Condition: "primary", CampusId: campusId,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0] === true){
                formSuccess(`Note added successfully.`, "addNoteSubmit", "loadAddNoteSubmit", "cancelAddNoteBtn", "addNoteForm");
                setRead(false);
                setRepCount(0);
                document.getElementById("submitBtn").click()
            }
            else{
                formFail(`Error during add, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
            }
        });
    }

    function findDevice(){
        handleSubmitActions("find-device-btn", "load-find-device-btn");
        ApiRequester({reqEndpoint: "remotecommand", payload: {mac: serialNum?.toLowerCase(), command: "location"},
                            source: "portal", User: dData.user, CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if (data === true){
                formSuccess(`Find device sent successful, allow several minutes to locate.`, "addNoteSubmit", "loadAddNoteSubmit");
                setIsFinding(true);
                setFindCnt(true);
                setFindDate(getUTCTimestamp());
                handleSubmitActions("load-find-device-btn", "find-device-btn");
            }
            else{
                formFail(`Error during finding device, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
                handleSubmitActions("load-find-device-btn", "find-device-btn");
            }
        });
    }

    function activateDevice(){
        handleSubmitActions("activate-device-btn", "load-activate-device-btn");
        ApiRequester({reqEndpoint: "remotecommand", payload: {mac: serialNum?.toLowerCase(), command: "panic"},
                            source: "portal", User: dData.user, CampusId: campusId, ClientId: dData.sessionId}).then(data => {
            if (data === true){
                formSuccess(`Remote alarming sent successful, allow up to 30 seconds for activation.`, "addNoteSubmit", "loadAddNoteSubmit");
                setIsActivating(true);
                setFindCnt(true);
                setFindDate(getUTCTimestamp());
                handleSubmitActions("load-activate-device-btn", "activate-device-btn");
            }
            else{
                formFail(`Error during remote alarming device, error code: ${data[1]}`, "addNoteSubmit", "loadAddNoteSubmit");
                handleSubmitActions("load-activate-device-btn", "activate-device-btn");
            }
        });
    }

    const eventTableHeaders = <TableHeaders checkbox={false} headerData={eventHeaderData} checkAll={() => {}}
                                            writeAccess={true} sortOrder={""}
                                            checkboxHeaderId={"uCheckHead"} sortColumn={""} sorter={{}}
                                            setSorter={() => {}} modal={dData?.event_notes_active} modal_name={"Notes"} checkboxlist={[]}
                                            actionAppearance={() => {}}/>
    const notesTableHeaders = <TableHeaders checkbox={false} headerData={noteHeaderData}
                                            checkAll={() => {}} writeAccess={editRights} sortOrder={"asc"}
                                            sortColumn={"create_time"} sorter={{}}
                                            setSorter={() => {}} modal={false} checkboxlist={[]}
                                            actionAppearance={() => {}}/>

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
        </div>
    );

    return (
        <>
            <Navigation />
            <div className={"main-content"}>
                <Header preTitle={"Device Profile"}
                        Title={basicData?.manufacture_uuid ? `${basicData?.device_name} (${serverid_to_mac(basicData.manufacture_uuid)})` : "Device Missing"}
                        content={headerContent}/>
                <div className={"container-fluid"}>
                    <div className={"col"}>
                        <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                            <li key={"set-basic"} className={"nav-item"}>
                                <Button text={"Basic Info"} spinner={!basicLoaded}
                                        class={tabItem === "basic" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("basic")}/>
                            </li>
                            <li key={"set-reporting"} className={"nav-item"}>
                                <Button text={"Reporting"} spinner={!reportLoaded}
                                        class={tabItem === "reporting" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("reporting")}/>
                            </li>
                            <li key={"set-wellness"} className={"nav-item"}>
                                <Button text={"Wellness"} spinner={!wellnessLoaded}
                                        class={tabItem === "wellness" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("wellness")}/>
                            </li>
                            <li key={"set-find"} className={"nav-item"}>
                                <Button text={"Find My Device"} spinner={!basicLoaded}
                                        class={tabItem === "find" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("find")}/>
                            </li>
                        </ul>
                    </div>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <ProfileSkeleton />
                    </div>
                    <div className={tabItem === "basic" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "550px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}>Basic Information</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"basic-card-btn"}
                                       onClick={() => toggleCollapse("basic-card-btn", "basic-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"basic-card"}>
                                {deviceImg
                                    ?   <div className={"d-inline-block align-top"}
                                             style={{
                                                 borderRadius: "8px",
                                                 backgroundColor: "#f9fbfd",
                                                 width: "auto"
                                             }}>
                                            <img className={"align-top"}
                                                 style={{
                                                     width: "inherit",
                                                     height: "inherit",
                                                     padding: "4px",
                                                     borderRadius: "8px",
                                                     maxHeight: "275px"
                                                 }}
                                                 src={`${process.env.PUBLIC_URL}/static/image/${deviceImg}`} alt={""}/>
                                        </div>
                                    :   <></>
                                }
                                <form className={"d-inline align-top form-control-plaintext was-validated"}
                                      id={"basic-form"}>
                                    <div className={"mx-5 mt-2 align-top d-inline-block"} id={"basic-col1-div"}>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Device Name:</p>
                                            <p className={"ms-4"}
                                               id={"name-static"}>{basicData?.device_name ? basicData.device_name : ""}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Description:</p>
                                            <p className={"ms-4"}
                                               id={"description-static"}>{basicData?.descriptions ? basicData.descriptions : ""}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   style={{height: "30px", width: "256px"}} id={"description-edit"}
                                                   defaultValue={basicData?.descriptions ? basicData.descriptions : ""}
                                                   pattern={"^[0-9a-zA-Z_\\- ]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Category:</p>
                                            <p className={"ms-4"}
                                               id={"category-static"}>{basicData?.device_category_short_name ? basicData.device_category_short_name : ""}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Device Type:</p>
                                            <p className={"ms-4"}
                                               id={"device-type-static"}>{deviceType}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>MAC Address:</p>
                                            <p className={"ms-4"}
                                               id={"serialnum-static"}>{basicData?.manufacture_uuid ? serverid_to_mac(basicData.manufacture_uuid) : ""}</p>
                                            <input className={"ms-4 d-none form-control form-control-sm"}
                                                   required={true}
                                                   style={{height: "30px", width: "256px"}} id={"serialnum-edit"}
                                                   defaultValue={basicData?.manufacture_uuid ? basicData.manufacture_uuid : ""}
                                                   pattern={"^[A-Za-z0-9]+$"}/>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Model Number:</p>
                                            <p className={"ms-4"}
                                               id={"model-name-static"}>{basicData?.model_name ? basicData.model_name : ""}</p>
                                        </div>
                                    </div>
                                    <div className={"mx-5 mt-2 d-inline-block align-top"}
                                         id={"basic-col2-div"} style={{minWidth: "300px"}}>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Room:</p>
                                            <p className={"ms-4"}
                                               id={"model-name-static"}>{basicData?.area_name ? basicData.area_name : ""}</p>
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Attached To:</p>
                                            {basicLoaded
                                                ? <>
                                                    <p className={"ms-4"} id={"linked-static"}><Link
                                                        to={`/profiles/resident/${basicData?.resident_id}`}>{basicData?.resident_name ? basicData.resident_name : ""}</Link>
                                                    </p>
                                                    <select className={"ms-4 d-none form-select form-select-sm"}
                                                            onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                            style={{height: "30px", width: "256px"}}
                                                            id={"linked-edit"}
                                                            defaultValue={basicData?.resident_id ? basicData.resident_id : 0}>
                                                        <option value={0}>Unassigned</option>
                                                        {residentData.map((rItem, i) => {
                                                            return <option key={`linked-item-${i}`}
                                                                           value={rItem?.resident_id}>{rItem?.resident_first_name} {rItem?.resident_last_name}</option>
                                                        })}
                                                    </select>
                                                </>
                                                : <></>
                                            }
                                        </div>
                                        <div className={"d-flex"}>
                                            <p style={{minWidth: "125px"}}>Line Profile:</p>
                                            {basicLoaded
                                                ? <>
                                                    <p className={"ms-4"} id={"profile-static"}>{basicData?.profile_name ? basicData.profile_name : "No Profile"}</p>
                                                    <select className={"ms-4 d-none form-select form-select-sm"}
                                                            onChange={() => formCheck("basic-form", "save-basic-btn")}
                                                            style={{height: "30px", width: "256px"}}
                                                            id={"profile-edit"}
                                                            defaultValue={basicData?.dsp_profile_id ? basicData.dsp_profile_id : 0}>
                                                        {profileOptions}
                                                    </select>
                                                </>
                                                : <></>
                                            }
                                        </div>
                                    </div>
                                </form>
                                {basicLoaded && editRights
                                    ?   <>
                                            <Button text={"Edit"} class={"btn btn-primary float-end"} id={"edit-basic-btn"}
                                                    disabled={!editRights} onClick={() => {
                                                if (editRights) {
                                                    basicActionHandling()
                                                }
                                            }}/>
                                            <Button text={"Save"} class={"btn btn-primary float-end me-3 d-none"}
                                                    id={"save-basic-btn"}
                                                    disabled={!editRights} onClick={() => {
                                                if (editRights) {
                                                    basicSubmit()
                                                }
                                            }}/>
                                            <Button type={"button"} class={"btn btn-primary float-end mx-3 d-none"}
                                                    disabled={true}
                                                    spinner={true} text={""} id={"load-basic-btn"}/>
                                        </>
                                    :   <></>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "reporting" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"} style={{minWidth: "80px"}}>
                                        Reporting
                                    </h3>
                                    <div className={"d-none"} style={{display: "inline-block"}}
                                         id={"reporting-header-data"}>
                                        <h3 className={"ms-6 my-0 d-inline-block text-success"}>{!isNaN(hourData?.avgValue) ? hourData.avgValue : "?"} Alert/Week</h3>
                                        <h3 className={"mx-4 my-0 d-inline-block text-success"}>{!isNaN(weekData?.avgValue) ? weekData.avgValue : "?"} Avg/Resp</h3>
                                    </div>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"reporting-card-btn"}
                                       onClick={() => {
                                           toggleCollapse("reporting-card-btn", "reporting-card")
                                           document.getElementById("reporting-header-data").classList.toggle("d-none");
                                       }}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"reporting-card"}>
                                <div className={"row"}>
                                    <Link to={"/reports/alerts/run"} onClick={() => {
                                        setDeviceFilters(dData, deviceId, basicData?.device_name);
                                    }}>
                                        <Button text={"Run Detailed Report"} class={"btn btn-primary mb-4 float-end"}
                                                icon={true} iconClass={"fe fe-arrow-right-circle float-end ms-3"}/>
                                    </Link>
                                </div>
                                <div className={"row"}>
                                    <div className={"chart-container w-50 text-end align-top d-inline-block"}>
                                        {hourDataLoaded
                                            ?
                                            <HourlyLineAndBarChart
                                                style={{maxHeight: "425px"}}
                                                labels={hourData?.labels ? hourData.labels : ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",
                                                                "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]}
                                                x_axis={true}
                                                x_axis_title={"Time of the Day"}
                                                bar_axis={true}
                                                bar_axis_title={"Total Alarms"}
                                                bar_color={"#0081C7"}
                                                line_axis={true}
                                                line_axis_title={"Average Response Time"}
                                                line_color={"#BE4D25"}
                                                bar_data={hourData?.events ? hourData.events : []}
                                                line_data={hourData?.responses ? hourData.responses : []}
                                                bar_annotation={true}
                                                line_annotation={true}
                                                forceAspect={true}
                                                bar_annotation_value={hourData?.avgValue ? hourData.avgValue : 0}
                                                line_annotation_value={hourData?.avgResp ? hourData.avgResp : 0} />
                                            :
                                            (<div className={"text-center"}>
                                                <Button text={""} class={"border-0 bg-transparent btn"}
                                                        spinner={true}></Button>
                                            </div>)
                                        }
                                    </div>
                                    <div className={"chart-container w-50 text-center align-top d-inline-block"}>
                                        {weekDataLoaded
                                            ?
                                            <LineTrendingChart
                                                style={{maxHeight: "425px"}}
                                                x_axis={true}
                                                x_axis_title={"Weeks"}
                                                line_axis={true}
                                                line_axis_title={"Total Alarms"}
                                                lines={1}
                                                line_color={lineColors}
                                                line_labels={lineLabels}
                                                line_data={lineData}
                                                forceAspect={true}
                                                labels={lineAxisLabels} />
                                            :
                                            (<div className={"text-center"}>
                                                <Button text={""} class={"border-0 bg-transparent btn"}
                                                        spinner={true}></Button>
                                            </div>)
                                        }
                                    </div>
                                </div>
                                <div className={"row mt-5"}>
                                    <div className={"w-50 px-4"} style={{height: "400px"}}>
                                        {mapCont}
                                    </div>
                                    <div className={"w-50"} style={{maxHeight: "400px", overflowY: "auto"}}>
                                        <table className={"table table-sm table-white table-hover d-sm-table"}>
                                            <thead className={"sticky-table-head"} style={{top: 0, zIndex: 1}}>
                                            {eventTableHeaders}
                                            </thead>
                                            <tbody>
                                            {eventTableRows}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className={"row mt-5"}>
                                    <div className={"col-12 col-lg-6 col-xl"}>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "wellness" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"}
                                        style={{minWidth: "80px"}}>Wellness</h3>
                                </div>
                                <div>
                                    <i className={"fe fe-minus as-btn collapse-toggle p-2"} id={"wellness-card-btn"}
                                       onClick={() => toggleCollapse("wellness-card-btn", "wellness-card")}></i>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"wellness-card"}>
                                <div className={"ms-4"}>
                                    <div className={"d-block"}>
                                        <div className={"d-inline-block align-top me-4"}
                                             style={{minWidth: "125px"}}>Careflow Plan:
                                        </div>
                                        <div
                                            className={"d-inline-block"}>{careflow && careflow?.length > 0 ? careflow : "No Careflow"}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "find" ? "d-block" : "d-none"}>
                        <div className={"card"} style={{minWidth: "500px"}}>
                            <div className={"card-header d-flex justify-content-between"}>
                                <div>
                                    <h3 className={"card-header-title d-inline-block"} style={{width: "175px"}}>
                                        Remote Control Panel
                                    </h3>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div className={"card-body collapse collapse-content show"} id={"find-card"}>
                                <div className={"row"} style={{height: "500px"}}>
                                    <div className={"col-3"}>
                                        <ul style={{listStyle: "none"}} className={"p-0 text-center"}>
                                            <li>
                                                <Button text={isFinding ? "Locating.." : "Find Device"} id={"find-device-btn"} style={{minWidth: "84px"}}
                                                        class={`btn ${isFinding ? "btn-success" : "btn-primary"} w-75 py-4 my-4`}
                                                        onClick={() => {
                                                            if (!isFinding){
                                                                findDevice();
                                                            }
                                                        }} />
                                                <Button type={"button"} class={"btn btn-primary d-none w-75 py-4 my-4"} style={{minWidth: "84px"}}
                                                        disabled={true} spinner={true} text={"Transmitting"} id={"load-find-device-btn"}/>
                                            </li>
                                            <li>
                                                <Button text={isActivating ? "Locating.." : "Alarm Device"} id={"activate-device-btn"} style={{minWidth: "84px"}}
                                                        class={`btn ${isActivating ? "btn-success" : "btn-primary"} w-75 py-4 my-4`}
                                                        onClick={() => {
                                                            if (!isActivating){
                                                                activateDevice();
                                                            }
                                                        }} />
                                                <Button type={"button"} class={"btn btn-primary d-none w-75 py-4 my-4"} style={{minWidth: "84px"}}
                                                        disabled={true} spinner={true} text={"Transmitting"} id={"load-activate-device-btn"}/>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className={"col-9"}>
                                        {findMap}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"modal fade"} id={"addnotemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticAddNoteBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title text-capitalize"} id={"staticAddNoteBackdropLabel"}>Add
                                Note</h2>
                            <button type={"button"} className={"btn-close"} id={"addNoteClose"}
                                    data-bs-dismiss={"modal"} aria-label={"Close"}/>
                        </div>
                        <form id={"addNoteForm"} className={"was-validated"}>
                            <div className={"modal-body"}>
                                {dData?.event_notes_preform
                                    ? <div className={"form-floating d-block"}>
                                        <select className={"form-select form-select my-2"} id={"note"}
                                                required={true}
                                                onChange={(e) => {
                                                    if (e.target.value === "0") {
                                                        document.getElementById("freeform").classList.remove("d-none");
                                                        document.getElementById("note-freeform").required = true;
                                                    } else {
                                                        document.getElementById("note-freeform").required = false;
                                                        document.getElementById("freeform").classList.add("d-none");
                                                    }
                                                    formCheck("addNoteForm", "addNoteSubmit");
                                                }}>
                                            {prenoteOptions}
                                        </select>
                                        <label htmlFor={"note"} className={"form-label"}>Note</label>
                                    </div>
                                    :   <div className={"my-2 form-floating"}>
                                            <textarea className={"form-control pt-5"} id={"note"} required={true}
                                                      style={{height: "125px"}}
                                                      onKeyUp={() => formCheck("addNoteForm", "addNoteSubmit")}>

                                            </textarea>
                                            <label htmlFor={"note"} className={"form-label"}>Note</label>
                                            <div className={"invalid-feedback"}>
                                                Note required
                                            </div>
                                        </div>
                                }
                                <div className={"my-2 form-floating d-none"} id={"freeform"}>
                                    <textarea className={"form-control pt-5"} id={"note-freeform"}
                                              style={{height: "125px"}}
                                              onKeyUp={() => formCheck("addNoteForm", "addNoteSubmit")}>
                                    </textarea>
                                    <label htmlFor={"note-freeform"} className={"form-label"}>Note</label>
                                    <div className={"invalid-feedback"}>
                                        Note required
                                    </div>
                                </div>
                                {noteTableLength > 0
                                    ? <>
                                        <hr/>
                                        <table className={"table table-sm table-white table-hover"}>
                                            <thead className={isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}>
                                            {notesTableHeaders}
                                            </thead>
                                            <tbody id={"tBody"}>
                                            {noteTableRows}
                                            </tbody>
                                        </table>
                                    </>
                                    : <></>
                                }
                            </div>
                            <div className={"modal-footer"}>
                                <div>
                                    <button type={"button"} className={"btn btn-secondary"} id={"cancelAddNoteBtn"}
                                            data-bs-dismiss={"modal"}>Cancel
                                    </button>
                                    <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                            spinner={true} text={"Loading"} id={"loadAddNoteSubmit"}/>
                                    <button type={"button"} className={"btn btn-primary ms-3"} id={"addNoteSubmit"}
                                            onClick={() => addNoteSubmit()}>Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
        </>
    );
};

export default PalcareDevice;